export default function reducer(state = { loading: false, error: false, campaigns: [] }, action) {
    switch (action.type) {
        case 'FETCH_CAMPAIGN':
            return {
                ...state,
                loading: true,
            }
        case 'FETCH_CAMPAIGN_FAILED':
            return {
                ...state,
                error: true,
                loading: false,
            }
        case 'FETCH_CAMPAIGN_SUCCESS':
            return {
                ...state,
                loading: false,
                campaigns: action.payload.data,
            }
        default:
            return state
    }
}
